import React from "react";
import { GridToolsProvider, GridToolsProviderProps, useMedia } from "@axum/ax-design";
import { SPLIT_MEDIA } from "./styles";

const LABELS = { refresh: "Actualizar", expandAll: "Expandir todas", collapseAll: "Contraer todas" };

// En tarjetas van siempre las columnas de fábrica (useOrderColumns): el selector no cambiaría nada.
export const OrderToolsProvider = ({ columns, ...options }: GridToolsProviderProps) => {
  const cards = useMedia(SPLIT_MEDIA);
  return <GridToolsProvider {...options} columns={cards ? undefined : columns} labels={LABELS} />;
};
